import React from 'react'
import {pageComponentRenderer} from '../../../helpers/pageComponentRenderer'

const StrapiPageSection = ({page}) => {
    const render = pageComponentRenderer()

    return <>{page.content.map((component) => render(component))}</>
}

export default StrapiPageSection
